import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IQaModel} from '../../../core/models/qa.model';
import {MatDialog} from '@angular/material';
import {QuestionEditorDialogComponent} from './question-editor-dialog.component';

@Component({
  selector: 'app-questions-list',
  templateUrl: './questions-list.component.html',
  styleUrls: ['./questions-list.component.css']
})
export class QuestionsListComponent implements OnInit {
  @Output() qaList = new EventEmitter<IQaModel | IQaModel[]>();
  @Output() updateQA = new EventEmitter<IQaModel>();
  @Output() deleteQA = new EventEmitter<string>();
  @Input() showLabel = true;
  @Input() autoSave = false;
  @Input()
  set data(data: IQaModel[]) {
    console.log(data);
    this.qaListData = data;
  }

  qaListData: IQaModel[] = [] as IQaModel[];

  constructor(private dialog: MatDialog) {}

  ngOnInit() {}

  deleteQuestion(qa: IQaModel) {
    const index = this.qaListData.indexOf(qa);
    this.qaListData.splice(index, 1);
    this.deleteQA.emit(qa._id);
  }

  openEditor(m: string, q?: IQaModel) {
    const dialogRef = this.dialog.open(QuestionEditorDialogComponent, {
      panelClass: '',
      width: '400px',
      data: {
        mode: m,
        qa: q ? q : null,
      }
    });

    dialogRef.afterClosed().subscribe( (data: IQaModel) => {
      if (data) {
        if (m === 'add') {
          this.qaListData.push(data);
          if (this.autoSave) {
            this.qaList.emit(data);
          } else {
            this.qaList.emit(this.qaListData);
          }
        } else {
          const indexOfQa = this.qaListData.indexOf(q);
          this.qaListData[indexOfQa] = data;
          this.updateQA.emit(data);
        }
      }
    });
  }

}
